import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { WebShopService } from "../services/webShop.service";
import { WebShopMode } from "../services/IWebShopService";

@Injectable({
  providedIn: "root"
})
export class WebVoucherServiceGuard implements CanActivate {

  constructor(private _webShopService: WebShopService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const me = this;
    return new Promise<boolean>((resolve, reject) => {
      const webshopService = me._webShopService.getServiceMode();
      if (webshopService && webshopService === WebShopMode.Webvoucher) {
        me._webShopService.tryAndRouteToSingleVariableWebvoucher();
        resolve(false);
      } else {
        resolve(true);
      }
    });
  }
}
